<template>
    <dashboard-layout>
        <v-container fluid class="down-top-padding py-0">
            <BaseBreadcrumb
            :title="page.title"
            :icon="page.icon"
            :breadcrumbs="breadcrumbs"
            ></BaseBreadcrumb>
            <v-row dense>
                <v-col cols="12">
                    <table-report-monthly-bp></table-report-monthly-bp>
                </v-col>
            </v-row>
        </v-container>
    </dashboard-layout>
</template>

<script>
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
import TableReportMonthlyBp from './TableGrids/TableReportMonthlyBp.vue'

export default {
    name: 'ReportMonthlyBp',
    props: {

    },
    components: {
        DashboardLayout,
        BaseBreadcrumb,
        TableReportMonthlyBp,
    },
    data() {
        return {
            page: {
                title: "Monthly Order Transactions",
            },
            breadcrumbs: [
                { text: "Monthly Order Transactions", disabled: true },
            ],
        }
    },
    watch: {},
    computed: {},
    mounted: function () {},
    methods: {

    }
}
</script>

<style>

</style>
